export default __webpack_public_path__ + "static/media/iconeUser.c87f7d87.png";